<div class="container mt-5">
  @if (error$ | async; as error) {
    <h1>Tin Arm | Login</h1>
    <div class="alert alert-danger" role="alert">
      {{error.error_description}}
    </div>
  }
</div>